import React, { ReactElement } from 'react';
import { saveData } from "services/api/saveData";
import { ModalProps } from "../ModalContext";
import InvoiceModal from "../../../views/invoices/InvoiceModal";

// Creates an invoice from a project, either loose or billing every finished job which is not invoiced yet
export const handleCreateProjectInvoice = async ({
    itemId,
    initializeModal,
    setFloatingAlert,
    setButtonLoader,
    buttonAction,
    invoiceFinishedJobs,
    fetchData,
}: {
    itemId: number;
    initializeModal: (content: ReactElement<any>, props?: ModalProps, itemId?: number | null) => void;
    setFloatingAlert: Function;
    setButtonLoader: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
    buttonAction: string;
    invoiceFinishedJobs: boolean;
    fetchData?: () => void;
}) => {
    try {
        // Start the button loader
        setButtonLoader((prev) => ({ ...prev, [buttonAction]: true }));

        // Send the project id, with the flag to bill the finished jobs as sections
        const submitData: Record<string, any> = { project_id: itemId };
        if (invoiceFinishedJobs) {
            submitData.invoice_finished_jobs = true;
        }

        // Create the new invoice
        const response = await saveData({
            apiUrl: 'post_invoice',
            method: 'post',
            data: submitData
        });

        // Open the new invoice after succesfully creating and refresh the project
        if (response && response.status === 201) {
            const newInvoiceId = response.data.id;

            if (newInvoiceId) {
                initializeModal(
                    <InvoiceModal itemId={newInvoiceId} />,
                    { modalSize: 'large', itemId: newInvoiceId }
                )
            }

            // Refresh the project so the invoiced jobs show their indicator
            if (fetchData) fetchData();

            // Show success alert
            setFloatingAlert({
                type: 'success',
                message: 'validation.invoice.created_successfully',
            });
        }
    } catch (error) {
        setFloatingAlert({
            type: 'danger',
            message: 'validation.invoice.creation_failed',
        });
    } finally {
        // Stop the button loader
        setButtonLoader((prev) => ({ ...prev, [buttonAction]: false }));
    }
};
